<template>
  <div class="feedback-wrapper">
    <div class="title">
      Обратная связь
    </div>
    <div class="feedback-form">
      <div class="main">
        <div
          v-if="getGoodsLength > 0"
          class="goods-card"
        >
          <div class="image">
            <img
              :src="goods.images[0].url"
              :alt="goods.images[0].item_id"
            >
          </div>
          <div class="info">
            <span class="category-name">{{ goods.name }}</span>
<!--            <span class="brand-name">{{ goods.brand_name }}</span>-->
<!--            <span class="model">{{ goods.model }}</span>-->
<!--            <span class="features">{{ goods.features }}</span>-->
          </div>
        </div>
<!--        <div class="buttons mobile">-->
<!--          <MtButton class="feedback-btn">-->
<!--            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"-->
<!--                 viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve">-->
<!--              <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111-->
<!--                C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587-->
<!--                c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/>-->
<!--            </svg>-->
<!--          </MtButton>-->
<!--        </div>-->
        <MtForm v-on:send="sendFeedBack($event)"></MtForm>
      </div>
      <div class="other">
        <div class="text">
          <span>Если хотите стать нашим партнером, переходите по ссылке <a href="https://dclink.ua/catalog/brand/mikrotik/">DC Link</a>.</span>
          <span>Мы всегда открыты для сотрудничества.</span>
        </div>
      </div>
    </div>
    <MtModal v-if="isModalShown" v-on:close="isModalShown = false">
      <span slot="modal-title">Сообщение</span>
      <div slot="modal-message">
        <span>Ваше сообщение было отправлено на рассмотрение менеджеру.</span>
        <br>
        <span>С вами свяжутся в течении дня.</span>
      </div>
    </MtModal>
    <MtModal v-if="isErrorModalShown" v-on:close="isErrorModalShown = false">
      <span slot="modal-title">Сообщение</span>
      <div slot="modal-message">
        <span>Ошибка при отправке форма, проверьте правильность заполнения.</span>
      </div>
    </MtModal>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'

import MtForm from '../MtForm/MtForm'
import MtModal from '../MtModal/MtModal'
export default {
  name: 'Feedback',
  components: { MtModal, MtForm },
  props: ['id'],
  data () {
    return {
      isModalShown: Boolean,
      isErrorModalShown: Boolean
    }
  },
  created () {
    this.isModalShown = false
    this.isErrorModalShown = false
    const goods = this.$store.getters.getProductInfo(this.id)
    if (!goods && typeof this.id !== 'undefined') {
      this.$store.dispatch('getInitialData').then(() => {
        if (!this.$store.getters.getProductInfo(this.id)) {
          this.$router.push('/feedback')
        }
      })
    }
  },
  computed: {
    goods () {
      if (this.id) {
        return this.$store.getters.getProductInfo(this.id)
      }
      return undefined
    },
    getGoodsLength () {
      if (this.goods) {
        return Object.values(this.goods).length
      } else {
        return 0
      }
    }
  },
  methods: {
    sendFeedBack (feedbackData) {
      if (this.goods) {
        feedbackData = {
          ...feedbackData,
          id: this.goods && this.goods.id ? this.goods.id : null
        }
      } else {
        feedbackData = {
          ...feedbackData
        }
      }

      this.$store.dispatch('sendFeedBack', feedbackData).then(response => {
        if (response && response.data.success) {
          this.isModalShown = true
        }
      }).catch(err => {
        if (err.status === 422) {
          this.isErrorModalShown = true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../vars";

  .feedback-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      @include titleMixin;
    }
    .feedback-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      .other {
        width: 100%;
        margin-top: 10px;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          height: 1px;
          width: 80%;
          background-color: $btn-c;
          top: 0;
          left: 10%;
        }
        .text {
          font-size: 12px;
          display: flex;
          padding: 40px 10px 10px 10px;
          flex-direction: column;
          align-items: flex-start;
          span {
            padding: 4px 0;
            text-align: left;
          }
          a {
            color: $btn-c;
            &:visited {
              color: $btn-c;
            }
          }
        }
      }
      .buttons {
        padding-top: 10px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding-bottom: 30px;
        position: relative;
        &.mobile {
          display: none;
        }
      }
      .main {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
      }
      .fields {
        width: 250px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .feedback-field {
          border: 1px solid #dedede;
          background-color: #FFF;
          border-radius: 5px;
          padding: 5px 7px;
          margin-bottom: 10px;
          font-size: 12px;
          box-sizing: border-box;
          &.txta {
            font-family: OpenSans, sans-serif;
            min-width: 250px;
            max-width: 250px;
            min-height: 70px;
            max-height: 300px;
          }
        }
      }
      .goods-card {
        width: 200px;
        box-sizing: border-box;
        .image {
          background-color: #FFF;
          border-radius: 10px;
          box-shadow: 0 2px 8px 4px #eaeaea;
          height: 100px;
          width: 100px;
          margin-bottom: 10px;
          overflow: hidden;
          position: relative;
          box-sizing: border-box;
          padding: 10px;
          img {
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            left: 50%;
            max-width: 100%;
            max-height: 100%;
          }
        }
        .info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          flex: 1;
          max-width: 120px;
          .category-name {
            font-weight: bold;
            text-align: left;
            font-size: 14px;
          }
          .brand-name, .model, .features {
            font-size: 12px;
            text-align: left;
          }
        }
      }
    }
  }
  @media screen and (max-width: 450px) {
    .feedback-wrapper {
      .feedback-form {
        .buttons {
          display: none;
          box-sizing: border-box;
          &.mobile {
            display: flex;
            order: 3;
            padding-right: 20px;
          }
        }
        .main {
          flex-direction: column;
          align-items: center;
          .fields {
            width: 100%;
            padding: 0 20px;
            .feedback-field {
              max-width: 100%;
              min-width: 100%;
            }
          }
          .goods-card {
            width: 100%;
            display: flex;
            justify-content: space-between;
            order: 2;
            padding: 0 20px;
            .info {
              flex: unset;
              max-width: 180px;
              .category-name {
                height: 100%;
                width: 100%;
                display: block;
              }
            }
          }
        }
        .other {
          .text {
            padding: 40px 20px 10px 20px;
          }
        }
      }
    }
  }
</style>
